import { isPreviouslyListed } from 'src/helpers/previouslyListedHomes';
import { createExperimentPage, disabledPage } from 'src/lib/flow/experimentPage';
import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';
import { api } from 'src/store/api';

function isEnabled() {
  // Not Functional on this experimental page, passed for argument agreement
  // instead refer to async func in upgradesExperimentPage args
  return true;
}

function title(): string {
  return `Have you made any renovations?`;
}

function subtitle() {
  return `Let us know if you've made any major upgrades to the property. You'll be able to add more detail after your initial estimate. `;
}

const slug = () => 'upgrades';

const autoAdvance = () => true;

const upgradesPage: FlowPage = {
  slug,
  title,
  subtitle,
  isEnabled,
  autoAdvance,
  questions: (): FlowQuestion[] => [
    {
      key: 'home.has_upgrades',
      type: 'radio_single_select',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
  ],
};

const upgradesExperimentPage = createExperimentPage(
  'isPreviouslyListedExperimentFlag',
  {
    control: disabledPage('upgrades'),
    treatment: upgradesPage,
  },
  // eligibleWhenEnabled
  async (listenerApi) => {
    const appState = listenerApi.getState();
    const addressToken = appState.sellerInput.address.uuid;
    const { data } = await listenerApi.dispatch(api.endpoints.getValidata.initiate(addressToken));
    const confidenceData = data ?? [];
    const isPreviouslyListedResult = isPreviouslyListed(confidenceData);
    if (isPreviouslyListedResult) {
      return false;
    }
    return true;
  },
);

export default upgradesExperimentPage;
